import { Record, List } from 'immutable'

const DashboardRecord = Record({
  companyIds: List(),
  description: '',
  id: '', // id or uuid
  integrationSourceSystemIds: List(),
  isCustomerDashboard: false,
  isOwner: false,
  canEdit: false,
  dashboardUsers: List(),
  dashboardRoles: List(),
  isSystemDashboard: false,
  name: '',
})

export default DashboardRecord
